import request, { IWorkspaceResponse } from '/@/api/http/request'
import Xrequest from '/@/api/http/Xrequest '

// DRC 链路
const API_PREFIX = '/manage/api/v1'

export interface MenuQueryParam {
  name: string,
  level: number,
  visible: string,
  status: string,
  is_frame: number,
  menu_type: string
}

export interface MenuPageRequest {
  page: number
  page_size: number
  param: MenuQueryParam
}

export interface MenuParam {
  id: number,
  name: string,
  path: string,
  component: string,
  level: number,
  visible: string,
  status: string,
  icon: string,
  perms: string,
  remark: string,
  parent_id: number,
  order_num: number,
  is_frame: number,
  menu_type: string
}

/**
 * 分页接口
 * @param body
 * @returns
 */
export const getMenuPage = async function (body: MenuPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/menu/menu-page`
  const result = await request.post(url, body)
  return result.data
}

/**
 * 删除菜单
 * @param id
 * @returns
 */
export const deleteMenu = async function (id: number): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/menu/delete-menu/${id}`
  const result = await request.delete(url)
  return result.data
}

/**
 * 添加菜单
 * @param body
 * @returns
 */
export const addOrUpdateMenu = async function (body: MenuParam): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/menu/add-or-update-menu`
  const result = await request.post(url, body)
  return result.data
}

/**
 * 菜单树形结构
 * @param body
 * @returns
 */
export const getMenuTree = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/menu/get-menu-tree`
  const result = await request.get(url)
  return result.data
}

// 查询菜单列表
export async function listMenu (params: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/system/menu/list'
  const result = await Xrequest.get(url, { params })
  return result.data
}

// 查询菜单详细
export async function getMenu (menuId: string): Promise<IWorkspaceResponse<any>> {
  const url = `/system/menu/getInfo/${menuId}`
  const result = await Xrequest.get(url)
  return result.data
}

// 查询菜单下拉树结构
export async function treeselect (params): Promise<IWorkspaceResponse<any>> {
  const url = '/system/menu/treeselect'
  const result = await Xrequest.get(url, { params })
  return result.data
}

// 根据角色ID查询菜单下拉树结构
export async function roleMenuTreeselect (roleId: string): Promise<IWorkspaceResponse<any>> {
  const url = `/system/menu/roleMenuTreeselect/${roleId}`
  const result = await Xrequest.get(url)
  return result.data
}

// 新增菜单
export async function addMenu (data: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/system/menu/add'
  const result = await Xrequest.post(url, data)
  return result.data
}

// 修改菜单
export async function updateMenu (data: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/system/menu/edit'
  const result = await Xrequest.post(url, data)
  return result.data
}

// 删除菜单
export async function delMenu (menuId: string): Promise<IWorkspaceResponse<any>> {
  const url = `/system/menu/remove/${menuId}`
  const result = await Xrequest.get(url)
  return result.data
}

// 根据字典类型查询字典数据信息
export async function getDicts (dictType:string): Promise<IWorkspaceResponse<any>> {
  const url = `/system/dict/data/type/${dictType}`
  const result = await Xrequest.get(url)
  return result.data
}

/** 获取路由信息 */
export async function getRouters (params:{}):Promise<IWorkspaceResponse<any>> {
  const url = '/getRouters'
  const result = await Xrequest.get(url, { params })
  return result.data
}
